import React from 'react'

function MovieListHeading( {title} ) {
  return (
    <div className='col'><h1>{title}</h1></div>
    
  )
}

export default MovieListHeading